import AssignTicket from "./index";
import useNavigateWrapper from "../../../../../../shared/hooks/useNavigateWrapper";
import { MyExpRoute } from "../../../../routes/types";
import { useSearchParams } from "react-router-dom";
import QueryParamKey from "../../../../../../shared/enums/QueryParamKey";
import React from "react";
import { State } from "./types";
import { refreshDashboardData } from "../../../../context/dashboard/dataloader";
import { useQueryClient } from "react-query";
import { useRegDetail } from "shared/context/regDetail";
import { useParticipantDetails } from "apps/myExperience/context/participantDetails";

export default function AssignTicketWrapper() {
  const { navigate } = useNavigateWrapper();
  const [searchParams] = useSearchParams();
  const queryClient = useQueryClient();
  const { id: registrationId, eventSeriesId, currencyCode, name } = useRegDetail();
  const { participantDetails } = useParticipantDetails();
  const registrationParticipantId = participantDetails?.registrationParticipantId || "";
  const bulkTicketId = searchParams.get("bulkTicketId") || "";

  const assignTicketInitialState: State | undefined = React.useMemo(() => {
    const emailId = searchParams.get(QueryParamKey.EMAIL_ID);
    const regParticipantId = searchParams.get(QueryParamKey.REG_PARTICIPATION_ID);
    const stepNumber = parseInt(searchParams.get(QueryParamKey.STEP_NUMBER) || "");
    if (!regParticipantId || !emailId || !stepNumber || isNaN(stepNumber)) {
      return undefined;
    }
    return { step: stepNumber, workEmail: emailId, nonAttendeeParticipant: { id: regParticipantId } };
  }, [searchParams]);

  const onCloseHandler = React.useCallback(() => {
    if (assignTicketInitialState) {
      refreshDashboardData(queryClient, assignTicketInitialState.nonAttendeeParticipant?.id);
    }
    navigate(MyExpRoute.HOME.path);
  }, [navigate, queryClient, assignTicketInitialState]);

  return (
    <AssignTicket
      initialState={assignTicketInitialState}
      handleClose={onCloseHandler}
      registrationId={registrationId}
      currencyCode={currencyCode}
      eventSeriesId={eventSeriesId}
      registrationParticipantId={registrationParticipantId}
      registrationName={name}
      bulkTicketId={bulkTicketId}
      assignTicketSuccessHandler={onCloseHandler}
      canAssignTicketToSelf={true}
      ticketFormId=""
    />
  );
}
